/**
 * n-carousel-filters.js
 * Filtri a carosello scorrevole per griglia collezione Shopify.
 * Dropdown appeso a <body> per evitare clipping da overflow-x:auto.
 */
(function () {
  function boot() {
    var wrap = document.querySelector('.n-cf');
    if (!wrap) return;
    var sectionId = wrap.id.replace('n-cf-', '');

    var track = wrap.querySelector('.n-cf__track');
    if (!track) return;

    var chips = wrap.querySelectorAll('.n-cf__chip');
    if (!chips.length) return;

    var resetBtn = wrap.querySelector('.n-cf__reset');

    /* ── Overlay ── */
    var overlay = document.createElement('div');
    overlay.className = 'n-cf__overlay';
    document.body.appendChild(overlay);

    /* ── JSON dati prodotto ── */
    var dataEl = document.getElementById('n-cf-data-' + sectionId);
    var config = {};
    try { config = JSON.parse(dataEl.textContent); } catch (e) {}

    var grid = document.querySelector(config.gridSelector || '#product-grid');
    if (!grid) return;

    var products = config.products || [];

    /* ── Nascondi filtri nativi ── */
    if (config.hideNativeFilters !== false) {
      document.body.classList.add('n-cf-active');
    }

    /* ── Inietta data-attributes + tag overlay ── */
    var items = grid.querySelectorAll('.grid__item');
    for (var ii = 0; ii < items.length; ii++) {
      (function (item, idx) {
        var matched = null;
        var link = item.querySelector('a[href*="/products/"]');
        if (link) {
          var m = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
          if (m) {
            for (var i = 0; i < products.length; i++) {
              if (products[i].handle === m[1]) {
                matched = products[i];
                break;
              }
            }
          }
        }
        if (!matched && products[idx]) matched = products[idx];
        if (!matched) return;

        item.setAttribute('data-n-tags', matched.tags.join(','));
        item.setAttribute('data-n-avail', String(matched.available));
        item.setAttribute('data-n-price', String(matched.price));

        /* ── Tag visivi sulla card ── */
        if (config.showTags && matched.tags_raw && matched.tags_raw.length > 0) {
          if (!item.querySelector('.n-cf-product-tags')) {
            var tagsBox = document.createElement('div');
            tagsBox.className = 'n-cf-product-tags';
            for (var t = 0; t < matched.tags_raw.length; t++) {
              var tagEl = document.createElement('span');
              tagEl.className = 'n-cf-product-tag';
              tagEl.textContent = matched.tags_raw[t];
              tagsBox.appendChild(tagEl);
            }
            item.insertBefore(tagsBox, item.firstChild);
          }
        }
      })(items[ii], ii);
    }

    /* ── Stato ── */
    var activeFilters = {};
    var priceMin = null;
    var priceMax = null;
    var openChip = null;
    var activeDrop = null;

    /* ── Posiziona dropdown sotto il chip ── */
    function positionDrop(chip, drop) {
      var rect = chip.getBoundingClientRect();
      var dropW = drop.offsetWidth || 170;
      var left = rect.left;
      /* Non uscire a destra */
      if (left + dropW > window.innerWidth - 16) {
        left = rect.right - dropW;
      }
      if (left < 8) left = 8;
      drop.style.left = left + 'px';
      drop.style.top = (rect.bottom + 4) + 'px';
    }

    /* ── Apri dropdown: sposta nel body ── */
    function openDrop(chip) {
      if (openChip) closeDrop();
      var drop = chip.querySelector('.n-cf__drop');
      if (!drop) return;

      chip.classList.add('n-cf__chip--open');

      /* Sposta dropdown nel body */
      document.body.appendChild(drop);
      positionDrop(chip, drop);
      drop.classList.add('n-cf__drop--visible');
      overlay.classList.add('n-cf__overlay--visible');

      openChip = chip;
      activeDrop = drop;
    }

    /* ── Chiudi dropdown: rimetti nel chip ── */
    function closeDrop() {
      if (!openChip || !activeDrop) return;
      activeDrop.classList.remove('n-cf__drop--visible');
      openChip.appendChild(activeDrop);
      openChip.classList.remove('n-cf__chip--open');
      overlay.classList.remove('n-cf__overlay--visible');
      openChip = null;
      activeDrop = null;
    }

    /* ── Setup tag nav pills (riga superiore) ── */
    var tagPills = wrap.querySelectorAll('.n-cf__tagpill');
    if (tagPills.length) {
      activeFilters['tagnav'] = new Set();
      for (var tp = 0; tp < tagPills.length; tp++) {
        (function (pill) {
          pill.addEventListener('click', function (e) {
            e.stopPropagation();
            var val = pill.getAttribute('data-filter-value');
            if (activeFilters['tagnav'].has(val)) {
              activeFilters['tagnav'].delete(val);
              pill.classList.remove('n-cf__tagpill--active');
            } else {
              activeFilters['tagnav'].add(val);
              pill.classList.add('n-cf__tagpill--active');
            }
            showReset();
            filter();
          });
        })(tagPills[tp]);
      }
    }

    /* ── Setup ogni chip ── */
    for (var ci = 0; ci < chips.length; ci++) {
      setupChip(chips[ci]);
    }

    function setupChip(chip) {
      var group = chip.getAttribute('data-filter-group');
      var special = chip.getAttribute('data-special');

      if (special !== 'price' && special !== 'sort') {
        activeFilters[group] = new Set();
      }

      /* Toggle dropdown */
      chip.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('.n-cf__opt')) return;
        if (t.closest('.n-cf__price-form')) return;
        if (t.tagName === 'INPUT' || t.tagName === 'BUTTON') return;
        e.stopPropagation();

        if (openChip === chip) {
          closeDrop();
        } else {
          openDrop(chip);
        }
      });

      /* ── ORDINA PER ── */
      if (special === 'sort') {
        var sortOpts = chip.querySelectorAll('.n-cf__opt');
        for (var si = 0; si < sortOpts.length; si++) {
          sortOpts[si].addEventListener('click', function (e) {
            e.stopPropagation();
            var url = new URL(window.location.href);
            url.searchParams.set('sort_by', this.getAttribute('data-sort-value'));
            window.location.href = url.toString();
          });
        }
        return;
      }

      /* ── PREZZO ── */
      if (special === 'price') {
        var pMin = document.getElementById('n-cf-price-min-' + sectionId);
        var pMax = document.getElementById('n-cf-price-max-' + sectionId);
        var pBtn = document.getElementById('n-cf-price-apply-' + sectionId);
        if (!pMin || !pMax || !pBtn) return;

        pMin.addEventListener('click', function (e) { e.stopPropagation(); });
        pMax.addEventListener('click', function (e) { e.stopPropagation(); });
        pBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          priceMin = pMin.value !== '' ? parseFloat(pMin.value) : null;
          priceMax = pMax.value !== '' ? parseFloat(pMax.value) : null;
          chip.classList.toggle('n-cf__chip--active', priceMin !== null || priceMax !== null);
          closeDrop();
          showReset();
          filter();
        });
        return;
      }

      /* ── CHECKBOX (disponibilità, tag, custom) ── */
      var opts = chip.querySelectorAll('.n-cf__opt');
      for (var oi = 0; oi < opts.length; oi++) {
        opts[oi].addEventListener('click', function (e) {
          e.stopPropagation();
          var val = this.getAttribute('data-filter-value');
          if (activeFilters[group].has(val)) {
            activeFilters[group].delete(val);
            this.classList.remove('n-cf__opt--sel');
          } else {
            activeFilters[group].add(val);
            this.classList.add('n-cf__opt--sel');
          }
          badge(chip, group);
          filter();
        });
      }
    }

    /* ── Badge ── */
    function badge(chip, group) {
      var old = chip.querySelector('.n-cf__cnt');
      if (old) old.remove();
      var n = activeFilters[group].size;
      if (n > 0) {
        chip.classList.add('n-cf__chip--active');
        var b = document.createElement('span');
        b.className = 'n-cf__cnt';
        b.textContent = n;
        chip.children[0].after(b);
      } else {
        chip.classList.remove('n-cf__chip--active');
      }
      showReset();
    }

    function showReset() {
      var any = false;
      var keys = Object.keys(activeFilters);
      for (var k = 0; k < keys.length; k++) {
        if (activeFilters[keys[k]].size > 0) { any = true; break; }
      }
      if (resetBtn) {
        resetBtn.classList.toggle('n-cf__reset--vis', any || priceMin !== null || priceMax !== null);
      }
    }

    /* ── Filtra griglia ── */
    function filter() {
      for (var fi = 0; fi < items.length; fi++) {
        var item = items[fi];
        var show = true;
        var tags = (item.getAttribute('data-n-tags') || '').split(',');
        var avail = item.getAttribute('data-n-avail') === 'true';
        var price = parseFloat(item.getAttribute('data-n-price'));

        if (activeFilters.availability && activeFilters.availability.size > 0) {
          var wA = activeFilters.availability.has('available');
          var wS = activeFilters.availability.has('sold-out');
          if (wA && !wS && !avail) show = false;
          if (wS && !wA && avail) show = false;
        }

        if ((priceMin !== null || priceMax !== null) && !isNaN(price)) {
          if (priceMin !== null && price < priceMin) show = false;
          if (priceMax !== null && price > priceMax) show = false;
        }

        var gkeys = Object.keys(activeFilters);
        for (var gi = 0; gi < gkeys.length; gi++) {
          var g = gkeys[gi];
          if (g === 'availability') continue;
          if (activeFilters[g].size === 0) continue;
          var hit = false;
          activeFilters[g].forEach(function (v) {
            if (tags.indexOf(v) !== -1) hit = true;
          });
          if (!hit) show = false;
        }

        item.classList.toggle('grid__item--n-hidden', !show);
      }
    }

    /* ── Reset ── */
    if (resetBtn) {
      resetBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var keys = Object.keys(activeFilters);
        for (var k = 0; k < keys.length; k++) activeFilters[keys[k]].clear();
        priceMin = null;
        priceMax = null;

        var pMin = document.getElementById('n-cf-price-min-' + sectionId);
        var pMax = document.getElementById('n-cf-price-max-' + sectionId);
        if (pMin) pMin.value = '';
        if (pMax) pMax.value = '';

        var sels = wrap.querySelectorAll('.n-cf__opt--sel');
        for (var s = 0; s < sels.length; s++) sels[s].classList.remove('n-cf__opt--sel');

        var activePills = wrap.querySelectorAll('.n-cf__tagpill--active');
        for (var ap = 0; ap < activePills.length; ap++) activePills[ap].classList.remove('n-cf__tagpill--active');

        closeDrop();
        for (var c = 0; c < chips.length; c++) {
          chips[c].classList.remove('n-cf__chip--active');
          var b = chips[c].querySelector('.n-cf__cnt');
          if (b) b.remove();
        }
        resetBtn.classList.remove('n-cf__reset--vis');
        for (var i = 0; i < items.length; i++) items[i].classList.remove('grid__item--n-hidden');
      });
    }

    /* ── Chiudi click fuori ── */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.n-cf__chip') && !e.target.closest('.n-cf__drop')) {
        closeDrop();
      }
    });
    overlay.addEventListener('click', function () { closeDrop(); });

    /* ══════════ DRAWER ══════════ */
    var drawer = document.getElementById('n-cf-drawer-' + sectionId);
    var drawerBack = document.getElementById('n-cf-drawer-back-' + sectionId);
    var filterBtn = document.getElementById('n-cf-filter-btn-' + sectionId);
    var filterCnt = document.getElementById('n-cf-filter-cnt-' + sectionId);
    var drawerClose = document.getElementById('n-cf-drawer-close-' + sectionId);
    var drawerApply = document.getElementById('n-cf-drawer-apply-' + sectionId);
    var drawerCancel = document.getElementById('n-cf-drawer-cancel-' + sectionId);
    var drawerCancelCnt = document.getElementById('n-cf-drawer-cancel-cnt-' + sectionId);

    function openDrawer() {
      if (!drawer) return;
      drawerBack.classList.add('n-cf__drawer-back--vis');
      drawer.classList.add('n-cf__drawer--vis');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawerBack.classList.remove('n-cf__drawer-back--vis');
      drawer.classList.remove('n-cf__drawer--vis');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (filterBtn) filterBtn.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (drawerBack) drawerBack.addEventListener('click', closeDrawer);
    if (drawerApply) drawerApply.addEventListener('click', closeDrawer);

    /* Conta filtri totali attivi per badge */
    function countAllActive() {
      var n = 0;
      var keys = Object.keys(activeFilters);
      for (var k = 0; k < keys.length; k++) n += activeFilters[keys[k]].size;
      if (priceMin !== null || priceMax !== null) n += 1;
      return n;
    }

    function updateFilterBadge() {
      var n = countAllActive();
      if (filterCnt) {
        filterCnt.textContent = n;
        filterCnt.classList.toggle('n-cf__filter-cnt--vis', n > 0);
      }
      if (drawerCancelCnt) {
        drawerCancelCnt.textContent = n > 0 ? '(' + n + ')' : '';
      }
    }

    /* Sync stato drawer ↔ chip */
    var drawerOpts = drawer ? drawer.querySelectorAll('.n-cf__drawer-opt[data-drawer-group]') : [];
    for (var doi = 0; doi < drawerOpts.length; doi++) {
      (function (opt) {
        var grp = opt.getAttribute('data-drawer-group');
        var val = opt.getAttribute('data-filter-value');
        if (!activeFilters[grp]) activeFilters[grp] = new Set();

        opt.addEventListener('click', function () {
          if (activeFilters[grp].has(val)) {
            activeFilters[grp].delete(val);
            opt.classList.remove('n-cf__drawer-opt--sel');
          } else {
            activeFilters[grp].add(val);
            opt.classList.add('n-cf__drawer-opt--sel');
          }
          /* Sync chip dropdown corrispondente */
          var chipOpt = wrap.querySelector('.n-cf__chip[data-filter-group="' + grp + '"] .n-cf__opt[data-filter-value="' + val + '"], .n-cf__drop[data-filter-value="' + val + '"]');
          var matchingChip = wrap.querySelector('.n-cf__chip[data-filter-group="' + grp + '"]');
          if (matchingChip) {
            var allOpts = wrap.querySelectorAll('.n-cf__chip[data-filter-group="' + grp + '"] .n-cf__opt[data-filter-value="' + val + '"]');
            for (var ao = 0; ao < allOpts.length; ao++) {
              allOpts[ao].classList.toggle('n-cf__opt--sel', activeFilters[grp].has(val));
            }
            badge(matchingChip, grp);
          }
          /* Sync tag nav pill */
          if (grp === 'tagnav') {
            var pill = wrap.querySelector('.n-cf__tagpill[data-filter-value="' + val + '"]');
            if (pill) pill.classList.toggle('n-cf__tagpill--active', activeFilters[grp].has(val));
          }
          showReset();
          updateFilterBadge();
          filter();
        });
      })(drawerOpts[doi]);
    }

    /* Sort radio nel drawer */
    var drawerSortOpts = drawer ? drawer.querySelectorAll('.n-cf__drawer-opt[data-drawer-special="sort"]') : [];
    for (var dsi = 0; dsi < drawerSortOpts.length; dsi++) {
      drawerSortOpts[dsi].addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.getAttribute('data-sort-value'));
        window.location.href = url.toString();
      });
    }

    /* Prezzo nel drawer */
    var dpMin = document.getElementById('n-cf-drawer-pmin-' + sectionId);
    var dpMax = document.getElementById('n-cf-drawer-pmax-' + sectionId);
    function syncDrawerPrice() {
      if (dpMin) dpMin.value = priceMin !== null ? priceMin : '';
      if (dpMax) dpMax.value = priceMax !== null ? priceMax : '';
    }
    if (dpMin) dpMin.addEventListener('change', function () {
      priceMin = this.value !== '' ? parseFloat(this.value) : null;
      var pminChip = document.getElementById('n-cf-price-min-' + sectionId);
      if (pminChip) pminChip.value = this.value;
      showReset(); updateFilterBadge(); filter();
    });
    if (dpMax) dpMax.addEventListener('change', function () {
      priceMax = this.value !== '' ? parseFloat(this.value) : null;
      var pmaxChip = document.getElementById('n-cf-price-max-' + sectionId);
      if (pmaxChip) pmaxChip.value = this.value;
      showReset(); updateFilterBadge(); filter();
    });

    /* Cancella dal drawer = reset completo */
    if (drawerCancel) drawerCancel.addEventListener('click', function () {
      if (resetBtn) resetBtn.click();
      /* Reset stato visuale drawer */
      var sels = drawer.querySelectorAll('.n-cf__drawer-opt--sel');
      for (var s = 0; s < sels.length; s++) {
        if (sels[s].getAttribute('data-drawer-special') !== 'sort') {
          sels[s].classList.remove('n-cf__drawer-opt--sel');
        }
      }
      syncDrawerPrice();
      updateFilterBadge();
    });

    /* Hook su filter() per aggiornare badge ad ogni click */
    var origFilter = filter;
    filter = function () {
      origFilter();
      updateFilterBadge();
    };
    /* Aggiorna badge anche su click chip standard */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.n-cf')) {
        setTimeout(updateFilterBadge, 10);
      }
    });

    /* ── Riposiziona su scroll/resize ── */
    window.addEventListener('resize', function () {
      if (openChip && activeDrop) positionDrop(openChip, activeDrop);
    });
    track.addEventListener('scroll', function () {
      if (openChip && activeDrop) positionDrop(openChip, activeDrop);
    });
    window.addEventListener('scroll', function () {
      if (openChip && activeDrop) positionDrop(openChip, activeDrop);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();